function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["defaultDesensitized", "type", "content", "grade", "textStyle", "iconStyle", "start", "end", "fixedDesensitized"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { max } from 'lodash-es';
import { Space } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var gradeRange = {
  idNumber: {
    lower: {
      start: 6,
      end: function end(content) {
        return content.length - 4;
      }
    },
    middle: {
      start: 3,
      end: function end(content) {
        return content.length - 3;
      }
    },
    top: {
      start: 1,
      end: function end(content) {
        return content.length - 1;
      }
    }
  },
  bankCardNumber: {
    lower: {
      start: 6,
      end: function end(content) {
        return content.length - 6;
      }
    },
    middle: {
      start: 6,
      end: function end(content) {
        return content.length - 4;
      }
    },
    top: {
      start: 0,
      end: function end(content) {
        return content.length - 4;
      }
    }
  },
  telephone: {
    lower: {
      start: 3,
      end: function end(content) {
        return content.length - 4;
      }
    }
  },
  name: {
    lower: {
      start: 1,
      end: function end(content) {
        return content.length > 2 ? content.length - 1 : content.length;
      }
    }
  },
  email: {
    lower: {
      start: function start(content) {
        return content.split('@')[0].length > 3 ? 3 : 0;
      },
      end: function end(content) {
        return content.split('@')[0].length;
      }
    }
  },
  address: {
    lower: {
      start: function start(content) {
        var indexList = [content.indexOf('省'), content.indexOf('市'), content.indexOf('区')];
        var maxIndex = max(indexList);
        return maxIndex ? maxIndex + 1 : 0;
      },
      end: function end(content) {
        return content.length;
      }
    }
  }
};
var replaceOperate = function replaceOperate(content, start, end) {
  var startRep = content.substring(0, start);
  var endRep = content.substring(end, content.length);
  var replaceRange = end - start;
  if (replaceRange === Infinity) {
    return '*'.repeat(content.length);
  } else if (replaceRange > 0) {
    var desensitizeRep = '*'.repeat(end - start);
    return startRep + desensitizeRep + endRep;
  }
  return content;
};
var replaceContent = function replaceContent(type, content, grade, autoStart, autoEnd) {
  if (!content) return '-';
  var start = autoStart || 0;
  var end = autoEnd ? content.length - autoEnd : content.length;
  if (type) {
    var range = gradeRange[type][grade];
    if (!range) return replaceOperate(content, start, end);
    start = typeof range.start === 'function' ? range.start(content) : range.start;
    end = typeof range.end === 'function' ? range.end(content) : range.end;
  }
  return replaceOperate(content, start, end);
};
var style = {
  cursor: 'pointer'
};
var Desensitize = function Desensitize(props) {
  var _props$defaultDesensi = props.defaultDesensitized,
    defaultDesensitized = _props$defaultDesensi === void 0 ? true : _props$defaultDesensi,
    type = props.type,
    _props$content = props.content,
    content = _props$content === void 0 ? '' : _props$content,
    _props$grade = props.grade,
    grade = _props$grade === void 0 ? 'lower' : _props$grade,
    textStyle = props.textStyle,
    iconStyle = props.iconStyle,
    start = props.start,
    end = props.end,
    _props$fixedDesensiti = props.fixedDesensitized,
    fixedDesensitized = _props$fixedDesensiti === void 0 ? false : _props$fixedDesensiti,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(defaultDesensitized),
    _useState2 = _slicedToArray(_useState, 2),
    desensitized = _useState2[0],
    setDesensitized = _useState2[1];
  var changeDesensitize = function changeDesensitize() {
    setDesensitized(!desensitized);
  };
  return /*#__PURE__*/_jsxs(Space, _objectSpread(_objectSpread({}, otherProps), {}, {
    children: [/*#__PURE__*/_jsx("span", {
      style: textStyle,
      children: !fixedDesensitized && !desensitized ? content : replaceContent(type, content, grade, start, end)
    }), !fixedDesensitized && content && (desensitized ? /*#__PURE__*/_jsx(EyeOutlined, {
      onClick: changeDesensitize,
      style: _objectSpread(_objectSpread({}, style), iconStyle)
    }) : /*#__PURE__*/_jsx(EyeInvisibleOutlined, {
      onClick: changeDesensitize,
      style: _objectSpread(_objectSpread({}, style), iconStyle)
    }))]
  }));
};
export default Desensitize;